import LinkButton from '~/components/button/LinkButton';
import Page from '~/components/layout/page/Page';
import { useLoaderData } from './warrantyWindow';

export default function WarrantyWindowPage() {
  const { outsideOfWarrantyDisclaimer, outsideOfWarrantyTitle } =
    useLoaderData();

  return (
    <Page.Section className="mb-8" title={outsideOfWarrantyTitle}>
      <div className="flex flex-col gap-6">
        <p>{outsideOfWarrantyDisclaimer}</p>
        <LinkButton
          className="md:w-1/2"
          variant="filled"
          to=".."
          relative="path"
        >
          Continue
        </LinkButton>
      </div>
    </Page.Section>
  );
}
